<!-- 谈话记录 -->
<template>
  <div class="MemconForm">

    <el-form style="padding-top: 20px;" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
      <div class="item">
        <p class="title">个人信息</p>
        <el-row>
          <el-col :span="7">
            <el-form-item label="学生学号">
              <el-input :disabled="true" v-model="ruleForm.userID"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="学生姓名">
              <el-input :disabled="true" v-model="ruleForm.realName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="心理辅导员">
              <el-input :disabled="true" v-model="ruleForm.teachID"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="谈话时间">
              <el-date-picker :disabled="true" v-model="ruleForm.talkTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>

            <el-col :span="7">
              <el-form-item label="谈话地点">
                <el-input :disabled="true" v-model="ruleForm.talkAddress"></el-input>
              </el-form-item>
            </el-col>

          <el-col :span="7">
            <el-form-item class="a1" label="初评危机状态">
              <span v-if="ruleForm.firstCrisisGrade =='1'"  style="color: red;">红色预警</span>
              <span v-else-if="ruleForm.firstCrisisGrade == '2'"  style="color: rgba(252, 111, 68, 1);">橙色预警</span>
              <span v-else-if="ruleForm.firstCrisisGrade == '3'"  style="color: rgba(255, 196, 0, 1);">黄色预警</span>
              <span v-else-if="ruleForm.firstCrisisGrade == '4'"  style="color: #409EFF;">蓝色预警</span>
              <span v-else-if="ruleForm.firstCrisisGrade == '5'"  style="color: #00f670;">绿色预警</span>
              <span v-else-if="ruleForm.firstCrisisGrade == '6'">绿色预警</span>
            </el-form-item>
          </el-col>
        </el-row>


        <el-form-item style="position: relative;" class="a1" label="心理中心建议">
          <el-checkbox-group :disabled="true" v-model="ruleForm.psychCentralSuggests">
            <el-checkbox label="1"  name="type">精神专科就医</el-checkbox>
            <el-checkbox label="2"  name="type">心理咨询</el-checkbox>
            <el-checkbox label="3"  name="type">心理危机干预</el-checkbox>
            <el-checkbox label="4"  name="type">保密突破联系监护人</el-checkbox>
            <el-checkbox label="5"  name="type">报警急救</el-checkbox>
            <el-checkbox label="6"  name="type">严密守护</el-checkbox>
            <el-checkbox label="7"  name="type">密切陪护</el-checkbox>
            <el-checkbox label="8"  name="type">重点关注</el-checkbox>
            <el-checkbox label="9"  name="type">适当关注</el-checkbox>
            <el-checkbox label="10" name="type">正常交流</el-checkbox>
            <el-checkbox label="11" name="type">其他</el-checkbox>
          </el-checkbox-group>

          <el-input style="position: absolute;top: 45px;left: 520px;width: 240px;" v-model="ruleForm.otherSuggest" placeholder="其他" maxlength="100" show-word-limit></el-input>
        </el-form-item>
      </div>

      <div class="item textleft">
        <p class="title">学生近况</p>

        <el-form-item class="a2 fontweight" label="严重情况突出表现  自杀、自伤或伤害他人倾向">
          <el-radio-group v-model="ruleForm.suicidalFlg">
            <el-radio label="1">有</el-radio>
            <el-radio label="2">无</el-radio>
            <el-radio label="3">待确定</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item class="a3" label="关于伤害的情况">
          <el-checkbox-group v-model="ruleForm.damages">
            <el-checkbox label="1" name="type">自杀想法</el-checkbox>
            <el-checkbox label="2" name="type">自杀计划</el-checkbox>
            <el-checkbox label="3" name="type">自杀未遂</el-checkbox>
            <el-checkbox label="4" name="type">自杀实施中</el-checkbox>
            <el-checkbox label="5" name="type">自杀姿态</el-checkbox>
            <el-checkbox label="6" name="type">被动自杀</el-checkbox>
            <el-checkbox label="7" name="type">自伤自残</el-checkbox>
            <el-checkbox label="8" name="type">伤害他人</el-checkbox>
            <el-checkbox label="9" name="type">扩大性自杀</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="发生时间" class="occurrencetime">
          <el-date-picker v-model="ruleForm.suicidalDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
        </el-form-item>

        <el-form-item label="发生情况" class="occurrencestate">
          <el-input v-model="ruleForm.suicidalDetail" maxlength="1000" show-word-limit></el-input>
        </el-form-item>
        <el-divider content-position="right"></el-divider>

        <el-form-item class="fontweight" label="疑似重性精神障碍">
          <el-radio-group v-model="ruleForm.psychosesFlg">
            <el-radio label="1">有</el-radio>
            <el-radio label="2">无</el-radio>
            <el-radio label="3">待确定</el-radio>
          </el-radio-group>
        </el-form-item>
      
        <el-form-item class="a5" label="疑似出现">
          <el-checkbox-group v-model="ruleForm.suspectedAppears">
            <el-checkbox label="1" name="type">感知觉障碍</el-checkbox>
            <el-checkbox label="2" name="type">思维障碍</el-checkbox>
            <el-checkbox label="3" name="type">注意障碍</el-checkbox>
            <el-checkbox label="4" name="type">记忆障碍</el-checkbox>
            <el-checkbox label="5" name="type">定向力障碍</el-checkbox>
            <el-checkbox label="6" name="type">情感障碍</el-checkbox>
            <el-checkbox label="7" name="type">意志障碍</el-checkbox>
            <el-checkbox label="8" name="type">动作与行为障碍</el-checkbox>
            <el-checkbox label="9" name="type">意识障碍</el-checkbox>
            <el-checkbox label="10" name="type">自知力缺失</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="发生时间" class="occurrencetime">
          <el-date-picker v-model="ruleForm.psychosesDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
        </el-form-item>

        <el-form-item label="发生情况" class="occurrencestate">
          <el-input v-model="ruleForm.psychosesDetail" maxlength="1000" show-word-limit></el-input>
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item label="谈话时间" class="occurrencetime">
              <el-date-picker v-model="ruleForm.appearDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="谈话地点" class="occurrencetime">
              <el-input v-model="ruleForm.appearAddress" maxlength="100" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>



        <el-form-item label="发生情况" class="occurrencestate">
          <el-input v-model="ruleForm.appearDetail" maxlength="1000" show-word-limit></el-input>
        </el-form-item>
      </div>
      <div class="item textleft">
        <p class="title">干预工作情况</p>
        <el-form-item class="fontweight" label="上报领导情况">
          <el-radio-group v-model="ruleForm.reportLeaderFlg">
            <el-radio label="1">是</el-radio>
            <el-radio label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item class="b1" label="详情">
          <el-input type="textarea" v-model="ruleForm.reportLeaderDetail" maxlength="1000" show-word-limit></el-input>
        </el-form-item>

        <el-form-item class="a7" label="与家长沟通情况">
          <el-radio-group v-model="ruleForm.parentFlg">
            <el-radio label="1">是</el-radio>
            <el-radio label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item class="b2" label="详情">
          <el-input type="textarea" v-model="ruleForm.parentDetail" maxlength="1000" show-word-limit></el-input>
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item class="fontweight" label="就医情况">
              <el-radio-group v-model="ruleForm.hospitalFlg">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="医院名称" class="occurrencetime">
              <el-input v-model="ruleForm.hospitalName" maxlength="30" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item class="occurrencetime" label="医院诊断为">
              <el-input type="text" v-model="ruleForm.hospitalDetail" maxlength="1000" show-word-limit></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="服药情况">
              <el-radio-group v-model="ruleForm.medicineFlg">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item class="fontweight" label="是否在心理中心咨询">
              <el-radio-group v-model="ruleForm.counsultFlg">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item class="occurrencetime" label="咨询开始时间年份">
              <el-input type="number" v-model="ruleForm.counsultBegin" maxlength="4" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="咨询次数" class="occurrencetime">
              <el-input type="number" v-model="ruleForm.counsultTimes" maxlength="4"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item class="a11" label="推荐去心理中心">
              <el-radio-group v-model="ruleForm.recommendCounsultFlg">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item class="fontweight" label="实际是否参与咨询">
          <el-radio-group v-model="ruleForm.realityCounsultFlg">
            <el-radio label="1">是</el-radio>
            <el-radio label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item class="a13" label="心理联络员配合工作情况">
          <el-input type="textarea" v-model="ruleForm.contactWorkDetail"  maxlength="1000" show-word-limit></el-input>
        </el-form-item>

        <el-form-item class="a14" label="心理委员配合工作情况">
          <el-input type="textarea" v-model="ruleForm.committWorkDetail" maxlength="1000" show-word-limit></el-input>
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item label="对接部门" class="occurrencetime">
              <el-input v-model="ruleForm.contactDeptName" maxlength="30" show-word-limit></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item class="occurrencetime" label="为该生" >
              <el-input type="text" v-model="ruleForm.otherTeacherDetail" maxlength="1000" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="height:0;display: flex;">
          <el-form-item label="多方会商" style="visibility:hidden;height: 0;">
            <el-radio-group v-model="ruleForm.multiPartyFlg">
              <el-radio label="1">需要</el-radio>
              <el-radio label="2">不需要</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>

        <el-form-item class="a15" label="上次谈话后危机状态">
          <span v-if="ruleForm.talkCrisisGrade == '1'" style="color: #C20D04;">红色预警</span>
          <span v-else-if="ruleForm.talkCrisisGrade == '2'" style="color: rgba(252, 111, 68, 1);">橙色预警</span>
          <span v-else-if="ruleForm.talkCrisisGrade == '3'" style="color: rgba(255, 196, 0, 1);">黄色预警</span>
          <span v-else-if="ruleForm.talkCrisisGrade == '4'" style="color: #409EFF;">蓝色预警</span>
          <span v-else-if="ruleForm.talkCrisisGrade == '5'" style="color: #3AC282;">绿色预警</span>
          <span v-else-if="ruleForm.talkCrisisGrade == '6'">绿色预警</span>
        </el-form-item>
  <!-- ******11/3 -->
        <!-- <el-form-item class="a16" label="是否调整危机状态">
          <el-radio-group v-model="ruleForm.adjustCrisisFlg">
            <el-radio label="1">是</el-radio>
            <el-radio label="2">否</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <!-- <el-form-item  class="a17" label="调整后危机状态">
          <el-radio-group v-model="ruleForm.adjustCrisisGrade">
            <el-radio label="1">红色预警</el-radio>
            <el-radio label="2">橙色预警</el-radio>
            <el-radio label="3">黄色预警</el-radio>
            <el-radio label="4">蓝色预警</el-radio>
            <el-radio label="5">绿色预警</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm',1)">立即创建</el-button>
          <!-- <el-button type="primary" @click="submitForm('ruleForm',2)">保存</el-button> -->
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userID: '',//学生id
      ruleForm: {
        keyNo: '',//学生id
        TalkNo: '',//学生id
        userId:'',//学生id
        realName:'',//学生姓名
        teachID:'',//心理辅导员
        talkTime:'',//2023-01-01T00:00:00.000+08:00", 谈话时间
        talkAddress:'',//谈话地点
        firstCrisisGrade: '',//初评危机状态
        psychCentralSuggests:'',//心理中心建议
        otherSuggest: '',//其他建议
        suicidalFlg: '1',//自杀、自伤或伤害他人倾向
        suicidalDate:'',//自杀、自伤或伤害他人发生时间
        suicidalDetail:'',//自杀、自伤或伤害他人发生情况
        damages:[],//关于伤害的情况
        damageDetail:'',// 伤害详细描述
        psychosesFlg:'1',//疑似重性精神病
        psychosesDate:'',//疑似重性精神病发生时间
        psychosesDetail:'',//疑似重性精神病发生情况
        suspectedAppears:[],// 疑似出现
        appearDate:'',//疑似出现时间
        appearAddress:'',//疑似出现地点
        appearDetail:'',//疑似出现详情
        reportLeaderFlg:'1',//上报领导情况
        reportLeaderDetail:'',//上报领导详情
        parentFlg:'1',//与家长沟通情况
        parentDetail:'',//与家长沟通详情
        hospitalFlg:'1',//就医情况
        hospitalName:'',//医院名称
        hospitalDetail:'',//就医详情
        counsultFlg:'1',//是否在心理中心咨询
        counsultBegin:'',//在心理中心开始咨询年份
        counsultTimes:'',//在心理中心咨询次数
        recommendCounsultFlg:'1',//是否推荐咨询
        realityCounsultFlg:'1',//实际是否参与咨询
        contactWorkDetail:'',//心理联络员配合工作情况
        committWorkDetail:'',//心理委员配合工作情况
        contactDeptName:'',//对接其他部门名称
        otherTeacherDetail:'',//通过其他部门老师了解情况
        multiPartyFlg: '2',//多方会商是否需要
        talkCrisisGrade: '',//上次谈话后危机状态
        adjustCrisisFlg: '1',//是否调整危机状态
        adjustCrisisGrade: '',//调整后危机状态
        medicineFlg: '1',//服药情况
        status: '',//
        recordStatus: '',//
        updateTime: '',//
        opinion: '',//
        roleID: '',//
        Operate: 1,//
      },
      rules: {
        UserID: [
          { required: true, message: '请输入学生学号', trigger: 'blur' },
        ],
        realName: [
          { required: true, message: '请输入学生姓名', trigger: 'blur' },
        ],
        teachID: [
          { required: true, message: '请输入心理辅导员', trigger: 'blur' },
        ],
        talkTime: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ],
        talkAddress: [
          { required: true, message: '请输入谈话地点', trigger: 'blur' },
        ],
        psychCentralSuggests: [
          { type: 'array', required: true, message: '请至少选择一个心理中心建议', trigger: 'change' }
        ],
        suicidalFlg:[
          { required: true, message: '请选择自杀、自伤或伤害他人倾向', trigger: 'change' }
        ],
        damages: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ],
      },
      RoleID: '',
      DeptID: '',
    };
  },
  methods: {
    submitForm(formName, Operate) {
      this.ruleForm.Operate = Operate;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$Http_Post('/DistressPrediction/HeartToHeartConversation', { form: this.ruleForm }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
              if (this.Global.pdroleid(1071)) {
                this.$router.push({ path: '/Crisis/Crisis_Intervent_Committee'});
              } else {
                this.$router.push({ path: '/Crisis/Crisis_Intervent'});
              }
            } else {
              this.Global.request_failure(res.Message);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
  mounted() {
    this.RoleID = sessionStorage.getItem('RoleID');
    this.userID = [this.$route.query.UserId][0];
    this.ruleForm.userId = [this.$route.query.UserId][0];
    this.ruleForm.roleID = sessionStorage.getItem('RoleID');
    this.ruleForm.TalkNo = [this.$route.query.TalkNo][0];
    this.ruleForm.keyNo = [this.$route.query.KeyNo][0];
    // this.ruleForm.KeyNo = [this.$route.query.KeyNo][0];

    this.$Http_Post('/DistressPrediction/InterviewRecordEcho', { userId: this.userID,type: '2'}).then((res) => {
      if (res.Data) {
        this.ruleForm.userID = res.Data.tuUrgentPreTbl.userId;
        this.ruleForm.realName = res.Data.tuUrgentPreTbl.realName;
        this.ruleForm.teachID = res.Data.tuUrgentPreTbl.teachID;

        this.ruleForm.talkTime = res.Data.tuUrgentPreTbl.talkTime;
        this.ruleForm.talkAddress = res.Data.tuUrgentPreTbl.talkAddress;
        
        this.ruleForm.psychCentralSuggests = res.Data.tuUrgentPreTbl.psychCentralSuggests;
        this.ruleForm.firstCrisisGrade = res.Data.tuUrgentPreTbl.firstCrisisGrade;
      }
    });

    this.$Http_Post('/DistressPrediction/ToExamineData', { TalkNo: [this.$route.query.TalkNo][0],KeyNo:[this.$route.query.KeyNo][0]}).then((res) => {
      if (res.Data) {
        this.ruleForm.talkCrisisGrade = res.Data.talkCrisisGrade;
      }
    });
  },
  filters: {
    // dateFormat(datetime) {
    //   var dt = new Date(datetime);
    //   var y = dt.getFullYear();
    //   var M = dt.getMonth() + 1;
    //   var d = dt.getDate();
    //   var h = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours();
    //   var m = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes();
    //   var s = dt.getSeconds() < 10 ? '0' + dt.getSeconds() : dt.getSeconds();
    //   return `${y}-${M}-${d} ${h}:${m}:${s}`;
    // },
  },
};
</script>
<style>
.MemconForm {width: 100%;}
.MemconForm .item{background: #fff;border-radius: 8px;padding:0 26px 15px;margin-bottom:16px;}
.MemconForm .item .title{font-size: 16px;padding:20px 0 15px;font-weight: bold;}
.MemconForm .textleft .el-form-item__label{text-align: left;}
.MemconForm .fontweight .el-form-item__label{font-weight: bold;color: #000;}
.MemconForm .el-form-item__content .el-input {width:240px;}
.MemconForm .occurrencetime .el-input {width: 360px;}
.MemconForm .occurrencestate .el-input {width: 100%;}
.MemconForm .occurrencestate .el-input .el-input__inner{min-height: 58px;}
.MemconForm .a1 .el-form-item__content .el-checkbox-group  {width: 850px;}
.MemconForm .a1 .el-form-item__label  {width: 130px !important;}
.MemconForm .a2 .el-form-item__label  {width: 330px !important;}
</style>
